import React from 'react';
import { Mail, Phone } from 'lucide-react';

const CALENDLY_URL = 'https://calendly.com/swallacemeeting/bizdevconsult';

const Footer = () => {
  return (
    <footer data-testid="footer" className="section-sm" style={{ backgroundColor: 'var(--bg-primary)', borderTop: '1px solid var(--border-light)' }}>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_smb-sales-service/artifacts/jgq0w3mu_logo-removebg-preview.png"
              alt="B2B Rev Co Logo"
              className="h-10 w-auto mb-4"
              style={{ filter: 'invert(1)' }}
            />
            <p className="text-sm mb-4" style={{ color: 'var(--text-secondary)', maxWidth: '320px' }}>
              Build predictable pipeline systems that generate better conversations and better opportunities.
            </p>
            <div className="flex flex-col gap-2">
              <a href="mailto:steve@b2brev.co" className="flex items-center gap-2 text-sm hover:underline" style={{ color: 'var(--text-muted)' }} aria-label="Email us">
                <Mail className="w-4 h-4" /> steve@b2brev.co
              </a>
              <a href="tel:+17745717985" className="flex items-center gap-2 text-sm hover:underline" style={{ color: 'var(--text-muted)' }} aria-label="Call us">
                <Phone className="w-4 h-4" /> (774) 571-7985
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4" style={{ color: 'var(--text-primary)' }}>Services</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#services" className="hover:underline" style={{ color: 'var(--text-muted)' }}>Outbound as a Service</a></li>
              <li><a href="#services" className="hover:underline" style={{ color: 'var(--text-muted)' }}>Outbound Infrastructure</a></li>
              <li><a href="#nimble" className="hover:underline" style={{ color: 'var(--text-muted)' }}>NIMBLE System</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4" style={{ color: 'var(--text-primary)' }}>Company</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#results" className="hover:underline" style={{ color: 'var(--text-muted)' }}>Results</a></li>
              <li><a href="#faq" className="hover:underline" style={{ color: 'var(--text-muted)' }}>FAQ</a></li>
              <li><a href="#contact" className="hover:underline" style={{ color: 'var(--text-muted)' }}>Contact</a></li>
              <li>
                <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: 'var(--text-muted)' }}>
                  Book a Call
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            &copy; {new Date().getFullYear()} B2B Rev Co. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs">
            <a href="#" className="hover:underline" style={{ color: 'var(--text-muted)' }}>Privacy Policy</a>
            <a href="#" className="hover:underline" style={{ color: 'var(--text-muted)' }}>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
